import {Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import * as _moment from 'moment';
const moment = _moment;
import * as _ from "lodash";
import {NzModalService} from "ng-zorro-antd/modal";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzFormatEmitEvent, NzTreeNode} from "ng-zorro-antd/tree";
import { EntityManagementSupportComponent } from '../../../tools/entity-management-support/entity-management-support.component';

export class SelectData {
  id: any;
  name: string;

  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}

@Component({
  selector: 'pi-role-privilege-management',
  templateUrl: './role-privilege-management.component.html',
  styleUrls: ['./role-privilege-management.component.css']
})
export class RolePrivilegeManagementComponent extends EntityManagementSupportComponent implements OnChanges {
  @ViewChild('modalContent') modalContent;
  @ViewChild('roleDataRuleModalContent') roleDataRuleModalContent;
  @Input('roleList') dataList = []
  @Input() rolePrivilegeList = [];
  @Input() roleBusinessList = [];
  @Input() roleDataRuleList = [];
  @Input() functionList = [];
  @Input() businessTypeList = [];
  @Input() departments = [];
  @Input() users = [];
  @Input() positions: SelectData[] = [];
  @Input() isLoading: boolean = false;
  @Input() extraHeaderColumn;
  @Input() extraDataColumn;
  @Input() roleModalTitle;
  @Input() dataPrivilegeModalTitle;
  @Input() showDepartmentControlled = false;
  @Input() showBusinessType = false;
  @Input() showRoleDataRule = false;
  @Input() pageSize = 10;

  @Output() saveRoleAction = new EventEmitter();
  @Output() removeRoleAction = new EventEmitter();
  @Output() saveRolePrivilegeAction = new EventEmitter();
  @Output() saveRoleBusinessAction = new EventEmitter();

  @Output() saveRoleDataRuleAction = new EventEmitter();
  @Output() removeRoleDataRuleAction = new EventEmitter();

  functionNameMap = {};
  nodes = [];
  defaultCheckedKeys = [];
  defaultSelectedKeys = [];
  checkedList = [];
  currentRoleBusinessList = [];
  currentRole;
  currentTabTitle = '功能权限';
  nodeWithChildren = [];
  departmentMap = {};
  roleDataRuleForm: FormGroup;
  detailRoleDataRule: any;

  constructor(
      public modalService: NzModalService,
      public notification: NzNotificationService,
      public translateService: TranslateService,
      private fb: FormBuilder,
      public injector: Injector
  ) {
    // super(translateService, modalService);
    super(injector);
    this.detailForm = this.fb.group({
      roleCode: [null, [Validators.required]],
      roleName: [null, [Validators.required]],
      roleType: [null, [Validators.required]],
      roleStatus: [null, [Validators.required]],
      departmentIds: [null, [Validators.required]],
      departmentPrivilegeIds: [null],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataList && this.rolePrivilegeList && this.roleBusinessList &&
        this.functionList && this.businessTypeList && this.roleDataRuleList && this.departments) {
      this.buildData();
    }
  }

  buildData() {
    const nodes = [];
    if (this.functionList) {
      this.functionList.forEach(d => {
        this.functionNameMap[d.id] = d.functionName;
        nodes.push({
          title: d.functionName,
          key: d.id,
          id: d.id,
          icon: d.functionIconUri == undefined ? '' : d.functionIconUri,
          metaData: d,
          expanded: d.functionType === 'SYS' ? true : false,
          isLeaf: true
        });
      });
    }
    this.nodes = this.buildTree(nodes);
    if (this.dataList[0]) {
      this.dataList[0].selected = true;
      if (this.currentRole) {
        this.radioClick(this.currentRole);
      } else {
        this.radioClick(this.dataList[0]);
      }
    }
    if (this.departments[0]) {
      const departmentNodes = [];
      this.departmentMap = {};
      this.departments.forEach(d => {
        departmentNodes.push({
          title: d.name,
          key: d.id,
          id: d.id,
          metaData: d,
          expanded: true,
          children: []
        });
        this.departmentMap[d.id] = d.name;
      });
    }
  }

  dataProcessBeforeSave(item) {
    if (!item.id) {
      // item.departmentId = -1;
      // item.organizationId = -1;
      item.displayOrder = item.displayOrder != undefined ? item.displayOrder : 1;
      item.displayed = true;
    }
    return item;
  }

  radioClick(item) {
    this.dataList.forEach(d => {
      if (item.id === d.id) {
        d.selected = true;
      } else {
        d.selected = false;
      }
    });
    this.getCurrentRole(item);
    this.defaultCheckedKeys = this.getCurrentDefaultCheckedKeys();
    this.currentRoleBusinessList = this.getCurrentRoleBusinessTypeList();
    this.resetExpandStatus(this.nodes);
  }

  resetExpandStatus(nodeChildren: any[]) {
    if (nodeChildren) {
      nodeChildren.forEach(node => {
        if (this.defaultCheckedKeys.includes(node.id) && !node.isLeaf) {
          node.expanded = true;
          this.resetExpandStatus(node.children);
        }
      })
    }
  }

  getCurrentRole(item) {
    this.currentRole = item;
  }

  getCurrentDefaultCheckedKeys() {
    if (this.currentRole) {
      return this.rolePrivilegeList.filter(f => f.sysRoleId === this.currentRole.id).map(f => f.sysFunctionId);
    } else {
      return [];
    }
  }

  getCurrentRoleBusinessTypeList() {
    if (this.currentRole) {
      return this.roleBusinessList.filter(f => f.sysRoleId === this.currentRole.id).map(f => f.businessType);
    } else {
      return [];
    }
  }

  buildTree(list) {
    const map = {};
    let node;
    const roots = [];
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.metaData.parentId !== -1) {
        if (this.nodeWithChildren.indexOf(node.metaData.parentId) < 0) {
          this.nodeWithChildren.push(node.metaData.parentId);
        }
        const targetOrder = list[map[node.metaData.parentId]];
        if (targetOrder) {
          if (!targetOrder.children) {
            targetOrder.children = [];
          }
          targetOrder.children.push(node);
          targetOrder.children.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
          targetOrder.isLeaf = false;
        } else {
          roots.push(node);
          roots.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
        }
      } else {
        roots.push(node);
        roots.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
      }
    }
    const endTime = new Date().getTime();
    return roots;
  }

  nzCheck(event) {

  }

  saveRolePermission() {
    if (this.currentTabTitle === '功能权限') {
      this.saveRolePrivilege();
    } else {
      this.saveRoleBusiness();
    }
  }

  getCheckedNodes() {
    this.checkedList = [];
    this.getCheckedItemByArray(this.nodes, this.currentRole);
  }

  getCheckedItemByArray(array, currentRole) {
    if (array) {
      array.forEach(a => {
        if (a.checked) {
          // 如果这个节点有上级节点，也需要保存
          if (!this.checkedList.find(i => i.sysFunctionId === a.metaData.parentId)) {
            this.checkedList.push({
              "description": null,
              // "organizationId": -1,
              "permissionFlag": 3,
              "sysFunctionId": a.metaData.parentId,
              "sysRoleId": currentRole.id,
              "updateUserId": -1,
              "valided": true
            });
          }

          this.checkedList.push({
            "description": null,
            // "organizationId": -1,
            "permissionFlag": 3,
            "sysFunctionId": a.metaData.id,
            "sysRoleId": currentRole.id,
            // "updateTime": moment().format(),
            "updateUserId": -1,
            "valided": true
          });
        }
        this.getCheckedItemByArray(a.children, currentRole);
      });
    }
  }

  tabClick(tabTitle) {
    this.currentTabTitle = tabTitle;
  }

  async showDetail(item) {
    this.detailItem = _.cloneDeep(item);
    const modal = this.modalService.create({
      nzTitle: this.roleModalTitle,
      nzStyle: {top: '5px'},
      nzWidth: this.modalWidth,
      nzContent: this.modalContent,
      nzOnOk: async () => {
        try {
          for (const i in this.detailForm.controls) {
            this.detailForm.controls[i].markAsTouched();
            this.detailForm.controls[i].updateValueAndValidity();
          }
          if (this.detailForm.valid) {
            const saveObj = _.cloneDeep(this.detailItem);
            this.saveRoleAction.emit({data: saveObj, modal: modal})
            // const result = await this.saveData(this.dataProcessBeforeSave(saveObj));
            // this.notification.success(this.labelSaveSuccess, '');
            // this.loadData();
            return false;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    });
  }

  async remove(item) {
    this.removeRoleAction.emit(item);
  }

  saveRolePrivilege() {
    this.getCheckedNodes();
    let arr = this.checkedList;
    if (arr && arr.length === 0) { // 如果要清空该角色的权限，则数组内放roleId
      arr = [{sysRoleId: this.currentRole.id}];
    }
    this.saveRolePrivilegeAction.emit(arr);
  }

  saveRoleBusiness() {
    let arr = this.currentRoleBusinessList.map(m => {
      return {
        businessType: m,
        description: null,
        // "organizationId": -1,
        // "updateUserId": -1,
        sysRoleId: this.currentRole.id,
      };
    });
    if (arr && arr.length === 0) { // 如果要清空该角色的权限，则数组内放roleId
      arr = [{sysRoleId: this.currentRole.id, businessType: undefined, description: undefined}];
    }
    this.saveRoleBusinessAction.emit(arr);
  }


  buildRoleDataRuleForm() {
    this.roleDataRuleForm = this.fb.group({
      sysRoleId: [this.currentRole.id, [Validators.required]],
      models: [null],
      description: [null],
      valided: [null]
    })
  }

  getCurrentRoleDataRuleList() {
    if (this.currentRole) {
      return this.roleDataRuleList.filter(f => f.sysRoleId === this.currentRole.id);
    } else {
      return [];
    }
  }

  addRoleDataRule() {
    this.showRoleDataRuleModal({});
  }

  modifyRoleDataRule(item) {
    this.showRoleDataRuleModal(item);
  }

  saveRoleDataRule(item) {
    this.saveRoleDataRuleAction.emit(item);
  }

  removeRoleDataRule(item) {
    this.removeRoleDataRuleAction.emit(item);
  }

  addNewScope() {
    if (!this.detailRoleDataRule.scopes) {
      this.detailRoleDataRule.scopes = [];
    }
    this.detailRoleDataRule.scopes.push({
      ids: [],
      scopeType: 'DEPT',
      recursion: true
    });
  }

  removeScope(index) {
    this.detailRoleDataRule.scopes.splice(index, 1);
  }

  showRoleDataRuleModal(item) {
    this.buildRoleDataRuleForm();
    this.detailRoleDataRule = _.cloneDeep(item);
    if (!this.detailRoleDataRule.sysRoleId) {
      this.detailRoleDataRule.sysRoleId = this.currentRole.id;
    }
    if (this.detailRoleDataRule.scopes) {
      this.detailRoleDataRule.scopes = JSON.parse(this.detailRoleDataRule.scopes);
    }

    this.modalService.create({
      nzTitle: this.dataPrivilegeModalTitle,
      nzContent: this.roleDataRuleModalContent,
      nzWidth: 1200,
      nzOnOk: () => {
        for (const i in this.roleDataRuleForm.controls) {
          this.roleDataRuleForm.controls[i].markAsTouched();
          this.roleDataRuleForm.controls[i].updateValueAndValidity();
        }
        if (!this.detailRoleDataRule.scopes || this.detailRoleDataRule.scopes.length == 0) {
          this.notification.error('可操作数据范围不能为空', '');
          return false;
        }
        if (this.roleDataRuleForm.valid) {
          const saveData = _.cloneDeep(this.detailRoleDataRule);
          this.saveRoleDataRuleAction.emit(this.processSaveData(saveData));
          return true;
        }
        return false;
      }
    })
  }

  processSaveData(saveData) {
    if (saveData.scopes) {
      saveData.scopes = JSON.stringify(saveData.scopes);
    }
    saveData.valided = saveData.valided ? true : false;
    return saveData;
  }

  openFolder(data: NzTreeNode | NzFormatEmitEvent): void {
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
  }

  selectDepartmentAll(fieldName) {
    this.detailItem[fieldName] = this.departments.map(departmet => departmet.id);
  }

}
